import React, { useEffect, useState } from 'react';
import { connect, history } from 'umi';
import InfiniteScroll from 'react-infinite-scroll-component';
import { get } from 'lodash';
import classnames from 'classnames';
import { PullToRefresh } from 'antd-mobile';
import previewCom from './components/index';
// import pbDetailResult from './mock';
import useGCPI18n from '@/hooks/useGCPI18n';
import { getDeviceType } from '@/utils/utils';
import useResponsive from '@/hooks/useResponsive';
import iconLoading from '@/assets/images/point/post_loading.gif';
import { trackSensors } from '@/utils/sensors';
import styles from './index.less';

function Home(props) {
  // const { currCataId, pointsList, currPageInfo, dispatch } = props;
  const { pointsList, currPageInfo, dispatch, pbPageCode, product, userDimension, isWeb } = props;
  const [contentInfo, setContentInfo] = useState({});
  const [hasTabCom, setHasTabCom] = useState(false);
  const [bgStyle, setBgStyle] = useState({});
  const { pageCode } = history.location.query;
  // 优先从URL获取，其次从localStorage读取（防止页面刷新后丢失）
  const cachedPageCode = window.localStorage.getItem('GCP_POINT_HOME_PAGE_CODE');
  const effectivePageCode = pageCode || cachedPageCode;
  useResponsive();
  const GCPI18n = useGCPI18n();

  const loadMoreData = async () => {
    // dispatch({
    //   type: 'pointShop/getProductSearch',
    //   payload: {
    //     catgIds: currCataId,
    //     pageInfo: {
    //       currentPage: Number(get(currPageInfo, 'currentPage')) + 1,
    //       pageSize: 10,
    //     },
    //   },
    // }).then(res => {
    //   if (res) {
    //     const currPointList = res?.pointProductList || [];
    //     dispatch({
    //       type: 'pointShop/save',
    //       payload: {
    //         pointsList: [...pointsList, ...currPointList],
    //         currPageInfo: res?.pageInfo,
    //       },
    //     });
    //   }
    // });
  };

  const qryPointsDetail = async () => {
    dispatch({
      type: 'pointShop/getHomeContentDXP',
      payload: {
        pageCode: effectivePageCode || pbPageCode || 'POINT_HOME_PAGE',
      },
    }).then(res => {
      if (res && res?.resultCode === '0') {
        const contentInfoTemp = {};
        if (res?.data?.containerList) {
          let compositionListTemp = [];
          (res?.data?.containerList || []).forEach(item => {
            if (item.compositionList) {
              compositionListTemp = [...compositionListTemp, ...item.compositionList];
            }
          });
          contentInfoTemp.children = compositionListTemp.map(item =>
            JSON.parse(item?.content || '{}'),
          );
        } else {
          contentInfoTemp.children = (res?.data?.compositionList || []).map(item =>
            JSON.parse(item?.content || '{}'),
          );
        }
        setContentInfo(contentInfoTemp);
        let newBgStyle = {
          backgroundColor:
            res?.data?.backgroundColor && res?.data?.backgroundColor.length > 0
              ? res?.data?.backgroundColor
              : '#fff',
          backgroundImage:
            res?.data?.backgroundImage && res?.data?.backgroundImage.length > 0
              ? `url(${res?.data?.backgroundImage})`
              : 'initial',
          backgroundSize: '100%',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
        };
        if (isWeb) {
          newBgStyle = {
            ...newBgStyle,
            backgroundColor: '#FFF',
          };
        }
        setBgStyle(newBgStyle);
        const pointCpmList = res?.data?.pageCompositionList || [];
        const filterTypeList = pointCpmList.filter(
          item => JSON.parse(item.content)?.type === 'TabCategory',
        );
        if (filterTypeList.length > 0) {
          setHasTabCom(true);
        }
      }
    });
  };

  useEffect(() => {
    qryPointsDetail();
    if (effectivePageCode) {
      // 将初始化的pageCode存储起来，后面兑换成功后会返回首页，此时会使用pageCode
      // 同时写入localStorage，防止页面刷新（如PullToRefresh的location.replace）后store重置导致丢失
      window.localStorage.setItem('GCP_POINT_HOME_PAGE_CODE', effectivePageCode);
      dispatch({
        type: 'pointShop/updateState',
        payload: {
          pbPageCode: effectivePageCode,
        },
      });
    }
  }, []);

  useEffect(() => {
    if ((contentInfo?.children || []).length > 0) {
      trackSensors('PointMallView', {
        product,
        userDimension,
      });
    }
  }, [contentInfo]);

  const handleRefresh = async () => {
    // window.location.reload();
    // 使用 replace 方法刷新页面
    window.location.replace(window.location.href);
    // await qryPointsDetail();
  };

  const Loading = () => (
    <div className={styles.loadingWrap}>
      <div className={styles.circleBox}>
        <img src={iconLoading} alt="" />
      </div>
    </div>
  );

  return (
    // <div style={{ height: '100vh', background: '#f5f5f5' }}>
    <PullToRefresh
      onRefresh={handleRefresh}
      completeText=""
      canReleaseText=""
      pullingText=""
      refreshingText={<Loading />}
    >
      <div className={styles.pageWrap}>
        <div
          className={classnames(
            styles.h5Container,
            contentInfo?.children?.length > 0 &&
              contentInfo?.children[0].type !== 'NavigationBar' &&
              getDeviceType() !== 'desktop' &&
              styles.noHeaderWrap,
          )}
          style={bgStyle}
        >
          <>
            {(contentInfo?.children || []).map((item, index) => {
              const Field = previewCom[item.type];
              return (
                <div key={index}>{Field && <Field {...item.props} dispatch={dispatch} />}</div>
              );
            })}
            {hasTabCom && (
              <InfiniteScroll
                dataLength={pointsList.length}
                scrollableTarget="scrollableDiv"
                next={loadMoreData}
                hasMore={pointsList.length < get(currPageInfo, 'total')}
              >
                {pointsList.length < get(currPageInfo, 'total') ? (
                  <>
                    <span>{GCPI18n('lb_loading')}</span>
                  </>
                ) : (
                  <span />
                )}
              </InfiniteScroll>
            )}
            {props.children /* DrawerLayer 渲染在这里 */}
          </>
        </div>
      </div>
    </PullToRefresh>
  );
}

export default connect(({ pointShop, index }) => ({
  ...pointShop,
  product: index.product,
  userDimension: index.userDimension,
  isWeb: index.isWeb,
}))(Home);
